<template>
  <div class="container1 price5">
    <div class="price-content-top">
      <h2>渲染价格</h2>
      <p class="price-top-well">充值畅享七折，超值福利来袭</p>
      <ul class="price-type-list flex-align-center flex-center" >  
        <li @click="togglePriceType('CPU')" :class="isActive ? 'active' : ''">CPU</li>
        <li @click="togglePriceType('GPU')" :class="!isActive ? 'active' : ''">GPU</li>
      </ul>
      <div class="price-type-desc flex-align-center flex-center hidden-md-and-down" v-if="isActive">
        <span class="active"> 原价： </span>
        <p class="price-desc"> 20核心/40线程(2.00元/机时) <span class="active">；</span> 28核心/56线程(2.80元/机时) <span class="active">；</span> 52核心/104线程(4.48元/机时) </p>
      </div>
      <div class="price-type-desc flex-align-center flex-center hidden-md-and-down" v-else>
        <span class="active"> 原价： </span>
        <p class="price-desc"> 1080Ti(3.00元/机时)<span class="active">；</span> 3060(3.50元/机时) <span class="active">；</span> 3090(6.00元/机时) </p>
      </div>
    </div>
    <div class="price-content ">
      <div class="price-detail-box ">
        <ul class="flex-align-center flex-between head">
          <li>
            机型规格
          </li>
          <li>
            <p class="detail-item-p">渲染优悦卡会员价格</p>
            <span class="detail-remark"> (充值 > 0元) </span>
          </li>
          <li>
            <p class="detail-item-p discount-6">渲染尊耀卡会员价格</p>
            <span class="detail-remark"> (单笔充值 ≥ 1000元) </span>
          </li>
          <li>
            <p class="detail-item-p discount-5">渲染至尊畅享卡会员价格</p>
            <span class="detail-remark"> (单笔充值 ≥ 5000 元) </span>
          </li>
        </ul>
        <div v-if="isActive">
          <ul class="flex-align-center flex-between price-date-list" >
            <li class="price-date">
              <p>20核心/40线程</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.40</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.20</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.00</span>元 /机时</p>
            </li>
          </ul>
          <ul class="flex-align-center flex-between price-date-list" >
            <li class="price-date">
              <p>28核心/56线程</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.96</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.68</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.40</span>元 /机时</p>
            </li>
          </ul>
          <ul class="flex-align-center flex-between price-date-list" >
            <li class="price-date">
              <p>52核心/104线程</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">3.14</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">2.69</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">2.24</span>元 /机时</p>
            </li>
          </ul>
        </div>
        <div v-else>
          <ul class="flex-align-center flex-between price-date-list" >
            <li class="price-date">
              <p>1080Ti</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">2.10</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.80</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.50</span>元 /机时</p>
            </li>
          </ul>
          <ul class="flex-align-center flex-between price-date-list" >
            <li class="price-date">
              <p>3060</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">2.45</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">2.10</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">1.75</span>元 /机时</p>
            </li>
          </ul>
          <ul class="flex-align-center flex-between price-date-list" >
            <li class="price-date">
              <p>3090</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">4.20</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">3.60</span>元 /机时</p>
            </li>
            <li class="price-date">
              <p><span class="price-date-item">3.00</span>元 /机时</p>
            </li>
          </ul>
        </div>
        <div class="price-date-list flex-center">
          <div>
            领新人福利<span class="price-date-go" @click="goto(1)">立即渲染</span>，更多优惠请<span class="price-date-go" @click="goto(2)">点击咨询</span>
          </div>
        </div>
      </div>
    </div>
    <div class="price-content price-remark">
      <p>备注：</p>
      <p>1. 渲染费用 = 渲染时间(h) × 渲染单价 </p>
      <p v-if="isActive">2. 内存默认64G，如选择内存更大的机器，会有额外费用</p>
      <p v-else>2. 如果选用机器是单卡或双卡，实际收费会按照实际选择卡数计算 </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Price5',
  data() {
    return {
      isActive: true, // 默认选中CPU
    };
  },
  methods: {
    togglePriceType(type) {
      this.isActive = type === 'CPU';
    },
    goto(type) {
      if (type == 1) {
        window.open('https://v.renderg.com/#/register?flag=register&origin=web', '_blank')
      }
      if (type == 2) {
        window.open('https://work.weixin.qq.com/kfid/kfc3d3bae48689a107f', "_blank")
      }
    }
  },
};
</script>